import { Card, CardContent } from "@/components/ui/card";
import { Icon3D } from "@/components/Icon3D";

export function DashboardCard({ icon: Icon, icon3d, label, value, sublabel, accent = "teal", testId }) {
  const accentMap = {
    teal:   "from-teal/25 to-transparent text-teal",
    gold:   "from-gold/25 to-transparent text-gold",
    navy:   "from-secondary/40 to-transparent text-foreground",
    danger: "from-destructive/25 to-transparent text-destructive",
  };
  const accentClass = accentMap[accent] || accentMap.teal;
  const ringMap = {
    teal:   "ring-teal/20",
    gold:   "ring-gold/20",
    navy:   "ring-secondary/30",
    danger: "ring-destructive/20",
  };

  return (
    <Card className="glass-card glass-card-hover overflow-hidden relative group" data-testid={testId}>
      {/* Accent gradient backdrop — carries the per-card color signal */}
      <div className={`pointer-events-none absolute inset-0 bg-gradient-to-br ${accentClass} opacity-40`} />
      <div className={`pointer-events-none absolute inset-0 rounded-2xl ring-1 ${ringMap[accent] || ringMap.teal} opacity-50`} />

      <CardContent className="p-5 relative">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground font-semibold">{label}</p>
            <p className="text-3xl font-heading font-bold mt-2 tracking-tight">{value}</p>
            {sublabel && <p className="text-xs text-muted-foreground mt-1">{sublabel}</p>}
          </div>
          {icon3d ? (
            <Icon3D name={icon3d} size={44} fallback={Icon} alt="" />
          ) : Icon ? (
            <div className="icon-tile h-10 w-10 shrink-0">
              <Icon className="h-5 w-5" strokeWidth={1.6} />
            </div>
          ) : null}
        </div>

        {/* Sparkline decoration */}
        <svg className="absolute bottom-0 left-0 right-0 w-full opacity-40 pointer-events-none" height="28" viewBox="0 0 200 28" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <linearGradient id={`spark-${accent}-${testId || 'x'}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="currentColor" stopOpacity="0.25" className="text-primary" />
              <stop offset="100%" stopColor="currentColor" stopOpacity="0" className="text-primary" />
            </linearGradient>
          </defs>
          <path d="M0,22 L20,18 L40,20 L60,12 L80,14 L100,8 L120,11 L140,4 L160,6 L180,2 L200,3 L200,28 L0,28 Z" fill={`url(#spark-${accent}-${testId || 'x'})`} />
          <path d="M0,22 L20,18 L40,20 L60,12 L80,14 L100,8 L120,11 L140,4 L160,6 L180,2 L200,3"
                fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-primary/50" />
        </svg>
      </CardContent>
    </Card>
  );
}
